export default __webpack_public_path__ + "static/media/scrollGrey.e4f143f1.svg";